if(!window.boxIntersect){window.boxIntersect = {};}
if(!window.boxIntersect.lib){window.boxIntersect.lib = {};}
if(!window.boxIntersect.lib.partition){window.boxIntersect.lib.partition = {};}

(function (global, module, exports) {
'use strict'

module.exports = genPartition

var code = 'for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m'

function genPartition(predicate, args) {
  var fargs ='abcdef'.split('').concat(args)
  var reads = []
  if(predicate.indexOf('lo') >= 0) {
    reads.push('lo=e[k+n]')
  }
  if(predicate.indexOf('hi') >= 0) {
    reads.push('hi=e[k+o]')
  }
  fargs.push(
    code.replace('_', reads.join())
        .replace('$', predicate))
  return Function.apply(void 0, fargs)
}
}).call(this, window, { get exports() { if(!window.boxIntersect.lib.partition) window.boxIntersect.lib.partition = {}; return window.boxIntersect.lib.partition; }, set exports(v) { if(typeof window.boxIntersect.lib.partition === "object") { for (var k in window.boxIntersect.lib.partition) { v[k] = window.boxIntersect.lib.partition[k]; } } window.boxIntersect.lib.partition = v; } }, window.boxIntersect.lib.partition);